import { useCheckEmailMutation } from '@/features/basket/api/mutation/check-email';
import { useState } from 'react';

export const useEmailCheck = () => {
  const [isEmailExists, setIsEmailExists] = useState(false);

  const {
    mutateAsync: asyncMutateCheckEmail,
    isPending,
    ...rest
  } = useCheckEmailMutation();

  const handleCheckEmail = async (email: string) => {
    try {
      const { emailTaken: isEmailExistsAsync } =
        await asyncMutateCheckEmail(email);
      setIsEmailExists(isEmailExistsAsync);

      return { isEmailExists: isEmailExistsAsync };
    } catch {
      return { isEmailExists };
    }
  };

  return { checkEmail: handleCheckEmail, isPending, isEmailExists, ...rest };
};
